$(function(){
  const userLang = navigator.language || navigator.userLanguage;
  const langCookie = document.cookie.match(/lang_override=(\w+)/);
  const hasLangOverride = langCookie ? langCookie[1] : null;

  if (!hasLangOverride && userLang.startsWith('ja') && !location.pathname.startsWith('/ja')) {
    document.cookie = "lang_override=ja; path=/; max-age=31536000"; // 1年保存
    window.location.href = '/ja' + location.pathname;
  }
});
